import { useQuery } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useCustomerById = (customerId) => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ['customer', customerId],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/users/customer/${customerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.customer;
    },
    { enabled: !!customerId && !!token }
  );
};

export default useCustomerById;
